/**
 * ChannelRow — Marketplace channel tile strip
 *
 * Shows Shopee, Lazada, TikTok tiles below the Pulse Row.
 * Lazada tile shows live data when connected, others remain upsell.
 */

import { motion } from "framer-motion";
import { ChannelTile } from "./ChannelTile";
import { GBPChannelTile } from "@/features/google-business/components/GBPChannelTile";
import {
  useMarketplaceConnections,
  useChannelSummary,
} from "@/features/channels/api/marketplaceHooks";
import { usePreferencesStore } from "@/lib/store/preferencesStore";

export function ChannelRow() {
  const { data: connections } = useMarketplaceConnections();
  const pulsePeriod = usePreferencesStore((s) => s.pulsePeriod);

  const isShopeeConnected = connections?.some(
    (c) => c.channel === "Shopee" && c.status === "Active"
  ) ?? false;

  const isLazadaConnected = connections?.some(
    (c) => c.channel === "Lazada" && c.status === "Active"
  ) ?? false;

  const isTiktokConnected = connections?.some(
    (c) => c.channel === "TikTok Shop" && c.status === "Active"
  ) ?? false;

  const { data: shopeeSummary } = useChannelSummary("shopee", isShopeeConnected, pulsePeriod);
  const { data: lazadaSummary } = useChannelSummary("lazada", isLazadaConnected, pulsePeriod);
  const { data: tiktokSummary } = useChannelSummary("tiktok", isTiktokConnected, pulsePeriod);

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, delay: 0.1 }}
      className="grid grid-cols-2 lg:grid-cols-3 gap-3 w-full"
    >
      <ChannelTile
        platform="shopee"
        isConnected={isShopeeConnected}
        summary={shopeeSummary}
      />
      <ChannelTile
        platform="lazada"
        isConnected={isLazadaConnected}
        summary={lazadaSummary}
      />
      <ChannelTile
        platform="tiktok"
        isConnected={isTiktokConnected}
        summary={tiktokSummary}
      />
      <GBPChannelTile />
    </motion.div>
  );
}
